<script>
import { onMounted } from 'vue'

import maintenanceOverlay from '@/components/shared/maintenance.vue'
import { getPlatformFromUrl, platformWhiteLabel } from '@/composables/utils/useWhitelabelService.js'

export default {
  name: 'App',

  components: {
    maintenanceOverlay
  },

  setup() {
    const platform = getPlatformFromUrl()

    const updateFavicon = () => {
      const faviconUrl = `/img/white-label/${platform}/favicon/icon-32x32.png`

      let link = document.querySelector("link[rel~='icon']")
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
      link.href = faviconUrl
    }

    const injectGTM = () => {
      const gtmID = platformWhiteLabel(platform, 'GTM_ID')
      if (gtmID != null) {
        const initializeGTM = (w, d, s, l, i) => {
          w[l] = w[l] || []
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
          var f = d.getElementsByTagName(s)[0]
          var j = d.createElement(s)
          var dl = l !== 'dataLayer' ? '&l=' + l : ''
          j.async = true
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
          f.parentNode.insertBefore(j, f)
        }

        initializeGTM(window, document, 'script', 'dataLayer', gtmID)
      }
    }

    onMounted(async () => {
      injectGTM()
      updateFavicon()
    })
  }
}
</script>

<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | transferbank` : `transferbank`
    }}</template>
  </metainfo>
  <router-view />
  <maintenance-overlay />
</template>

<style lang="scss">
@use './assets/css/style.scss' as *;
</style>
